import { createActionGroup, emptyProps } from '@ngrx/store';

export const AccountTeamPageActions = createActionGroup({
  source: 'Account Team Page',
  events: {
    'Page Opened': emptyProps(),
  },
});
